var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEconomicIndicators = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 37 37",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.12 17.687q.325-.345 1-.361v2.72q-.567-.178-.838-.387-.487-.38-.487-1.031 0-.596.325-.941M20.234 23.913q0 .875-.487 1.23-.28.203-.892.28v-3.03q.652.241.923.466.456.388.456 1.054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.871 10.462a6.795 6.795 0 0 0 4.388-6.354H11.672a6.795 6.795 0 0 0 4.387 6.354 7.915 7.915 0 0 0-7.064 7.87V31.2c0 .924.75 1.674 1.674 1.674h11.917a2.4 2.4 0 0 1-.066-.554v-3.064c0-.597.224-1.141.592-1.557a2.08 2.08 0 0 1-.366-1.179v-3.164c0-1.15.936-2.086 2.087-2.086h3.103v-2.939a7.915 7.915 0 0 0-7.065-7.87m.077 16.053q-.876.544-2.077.636v1.558h-.751v-1.542q-1.526-.17-2.28-.667-1.323-.89-1.3-3.037h2.092q.108.976.302 1.31.302.519 1.186.673v-3.308l-.628-.186q-1.48-.435-2.088-1.209t-.608-1.867q0-.721.236-1.309.236-.59.662-1.015.55-.55 1.225-.76.41-.131 1.2-.193v-1.03h.736v1.044q1.264.102 1.984.62 1.31.83 1.356 2.69h-2.038q-.062-.69-.233-1.008-.293-.55-1.069-.604v2.952q1.845.635 2.48 1.124 1.047.813 1.046 2.293 0 1.953-1.433 2.835"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.544 22.977c.21 0 .38.17.38.379v3.164c0 .21-.171.38-.38.38h-6.711a.38.38 0 0 1-.38-.38v-3.164c0-.21.17-.38.38-.38zM35.468 28.827a.43.43 0 0 1 .43.43v3.063a.43.43 0 0 1-.43.43H24.883a.43.43 0 0 1-.43-.43v-3.064a.43.43 0 0 1 .43-.43z"
  })));
};
export default SvgEconomicIndicators;